import { coursesManifest } from '@/features/courses/public'
import { subjectsManifest } from '@/features/subjects/public'
import { taxonomiesManifest } from '@/features/taxonomies/public'
import { membershipPlansManifest } from '@/features/memberships/public'
import { userMembershipsManifest } from '@/features/user-memberships/public'
import { learnerRewardsManifest } from '@/features/learner-rewards/public'
import { achievementsManifest } from '@/features/achievements/manifest'
import { userAchievementsManifest } from '@/features/user-achievements/manifest'
import { ttsManifest } from '@/features/tts/public'
import { publishManifest } from '@/features/publish/public'

export const featureManifests = [
  subjectsManifest,
  taxonomiesManifest,
  coursesManifest,
  membershipPlansManifest,
  userMembershipsManifest,
  learnerRewardsManifest,
  achievementsManifest,
  userAchievementsManifest,
  ttsManifest,
  publishManifest,
]
